import { useMutation, useQueryClient } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

interface Payload {
  firstName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  lastName?: string;
  role?: string;
  photoUrl?: string;
}

export default function useUpdateProfile() {
  const queryClient = useQueryClient();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const response = await fetch(`${getApiBaseUrl()}/api/v1/users/profile`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSuccess: () => {
      window.localStorage.removeItem('user_type');
      window.localStorage.removeItem('user');

      queryClient.invalidateQueries({ queryKey: ['PROFILE'] });
    },
  });
}
